export const search_json = 'https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/search2023_so.json';